/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './CardsOffer.css'

// reactstrap components
import {
    Badge,
    Button,
    Card,
    CardBody,
    Container,
    Row,
    Col,
} from "reactstrap";

class CardsOffer extends React.Component {

    render() {
        return (
            <>
                <section className="section section-lg">
                    <Container className="offer-container">
                         
                        <h2 className="mb-3">What we have to offer</h2>
                        <p className="mb-4" id="offer-description">
                            At Fred S. Keller, we're dedicated to providing our professionals with the most
                            effective tools for fostering communication and learning in children.                                 
                        </p>
                        
                        <Row className="justify-content-center">
                            <Col lg="12">
                                <Row className="row-grid">
                                    <Col lg="4">
                                        <Card className="card-lift--hover shadow border-0">
                                            <CardBody className="py-5">
                                                <div className="icon icon-shape mb-4 rounded-squircle">
                                                    <i className="fas fa-search offer-icon" />
                                                </div>
                                                <h6 className="offer-title">
                                                    Evidence-Based Methodologies
                                                </h6>
                                                <p className="description mt-3">
                                                    Our apps are built upon established research and best practices, 
                                                    ensuring that you're using proven methods to support children's development.  
                                                    We are committed to providing resources that are both effective and grounded in science.
                                                </p>
                                                
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="4">
                                        <Card className="card-lift--hover shadow border-0">
                                            <CardBody className="py-5">
                                                <div className="icon icon-shape mb-4 rounded-squircle">
                                                    <i className="ni ni-tablet-button offer-icon" />
                                                </div>
                                                <h6 className="offer-title">
                                                    Advanced Assessment Technologies
                                                </h6>
                                                <p className="description mt-3">
                                                    Our assessment tools leverage data-driven insights and intuitive interfaces to provide 
                                                    a comprehensive understanding of each child's unique learning profile.
                                                </p>
                                               
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="4">
                                        <Card className="card-lift--hover shadow border-0">
                                            <CardBody className="py-5">
                                                <div className="icon icon-shape mb-4 rounded-squircle">
                                                    <i className="ni ni-world-2 offer-icon" />
                                                </div>
                                                <h6 className="offer-title">
                                                    Seamless Integration
                                                </h6>
                                                <p className="description mt-3">
                                                    Our apps are designed to work together seamlessly, 
                                                    with a central system, creating a cohesive and efficient 
                                                    workflow for educators and therapists.
                                                </p>
                                                
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        )
    }
}

export default CardsOffer;